import type { RequestSummary } from "../api/requests";

/**
 * Hub row amount. Settled receive wins once a fulfilling operation exists.
 * Pending (and rows without a usable settled figure) stay on the requested amount.
 */
export function listRowReceiveAmount(
  request: Pick<RequestSummary, "amount" | "receiveAmount" | "operation">
): number {
  const settled = request.operation?.receiveAmount ?? request.receiveAmount;
  if (typeof settled === "number" && Number.isFinite(settled)) return settled;
  return request.amount ?? 0;
}
